import { gql } from "@apollo/client";

export const GET_ALL_FINANCE_TREE_TRANSACTIONS = gql`
  query GetAllFinanceTreeTransactions(
    $limit: Int!
    $page: Int!
    $filter: FinanceTreeTransactionFilterDto
  ) {
    getAllFinanceTreeTransactions(
      limit: $limit
      page: $page
      filter: $filter
    ) {
      transactions {
        id
        transactionNumber
        date
        description
        imageId
        totalDebit
        totalCredit
        total
        isBalanced
        createdAt
        updatedAt
      }
    }
  }
`;

